import * as Sentry from '@sentry/browser';
import { isDev } from './utils/env';

Sentry.init({
  dsn: 'https://62c66e44f6d148e3afacda75d292eecc@sentry.duoke.net/7',
  environment: process.env.NODE_ENV,
  enabled: !isDev(),
  release: process.env.VERSION,
  integrations: [new Sentry.Integrations.GlobalHandlers()],
});

Sentry.configureScope((scope) => {
  scope.setUser({ email: 'duokeserver163.com' });
});
